// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1JH5r","modalForm":"UpgradeEpcsModal_modalForm__HY2lt","modalFooter":"UpgradeEpcsModal_modalFooter__39UO2"};